module.exports = __webpack_public_path__ + "static/img/section02-01@m.cc712c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/samsung-svc/section02-01@m.jpg
// module id = vLO9
// module chunks = 0